export default __webpack_public_path__ + "static/media/group_life_dark.bfd28127.png";